import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../App";

const SIGNUPURL = "https://thrive-mqy3.onrender.com/v1/auth/patient/register";

const SignUp = () => {
  const { setUserInfo } = useContext(UserContext);
  const [firstName, setfirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordLength, setPasswordLength] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const navigator = useNavigate();

  function handleSignUp(e) {
    e.preventDefault();
    if (password.length < 8) {
      setPasswordLength(true);
      setTimeout(() => setPasswordLength(false), 5000);
      return;
    }

    if (password != confirmPassword) {
      setPasswordMatch(true);
      setTimeout(() => setPasswordMatch(false), 5000);
      return;
    }

    const newUser = {
      firstName,
      lastName,
      email,
      password,
    };

    setUserInfo(newUser);
    createUser();

    // navigator("/emailverification");
  }

  const createUser = async () => {
    try {
      const loginDetails = {
        firstName,
        lastName,
        email,
        password,
      };

      const userDetail = {
        method: "POST",
        body: JSON.stringify(loginDetails),
        headers: { "Content-Type": "application/json" },
      };

      const response = await fetch(SIGNUPURL, userDetail);
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.log("something went wrong" + error);
    }
  };
  return (
    <div>
      <div className="background flex bg-[#D4DDCC] min-h-[100vh]">
        <div id="bgImage" className="relative">
          <img
            src="https://res.cloudinary.com/dxswouxj5/image/upload/v1700577179/Signup%20image/sign-up-img_sgy6an.png"
            alt="signup"
            className="w-[600px] h-full"
          />
          <Link to="/">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518851/rsnuvxsp8itnttc6hk9u.png"
              alt=""
              className="w-20 h-20 absolute top-6 left-6 object-cover"
            />
          </Link>
        </div>
        <div className="container max-w-md mx-auto p-4">
          <h2 className="text-2xl font-semibold font-['Crimson Pro'] uppercase mt-10 mb-8">
            CREATE AN ACCOUNT
          </h2>
          <h3 className="text-xl font-normal font-['Crimson Pro'] capitalize mb-6">
            Let's Get Started with Your Sign Up
          </h3>
          <form name="signUp">
            <div className="form mb-6">
              <input
                type="text"
                name="name"
                value={firstName}
                onChange={(e) => setfirstName(e.target.value)}
                placeholder="First Name"
                required
                className="border-b-2 border-[#333] bg-transparent p-1 w-[95%] focus:border-[#333] outline-none transition border-opacity-30"
              />
            </div>
            <div className="form mb-6">
              <input
                type="text"
                name="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Last Name"
                required
                className="border-b-2 border-[#333] bg-transparent p-1 w-[95%] focus:border-[#333] outline-none transition border-opacity-30"
              />
            </div>
            <div className="form mb-6">
              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
                className="border-b-2 border-[#333] bg-transparent p-1 w-[95%] focus:border-[#333] outline-none transition border-opacity-30"
              />
            </div>
            <div className="form mb-6">
              <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
                className="border-b-2 border-[#333] bg-transparent p-1 w-[95%] focus:border-[#333] outline-none transition border-opacity-30"
              />
            </div>
            {passwordLength && (
              <p className="text-center mb-4 text-red-500 font-semibold -mt-2">
                Password should be more than 8 Characters!
              </p>
            )}
            <div className="form mb-6">
              <input
                type="password"
                name="confirm-password"
                placeholder="Confirm Password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                required
                className="border-b-2 border-[#333] bg-transparent p-1 w-[95%] focus:border-[#333] outline-none transition border-opacity-30"
              />
            </div>
            {passwordMatch && (
              <p className="text-center mb-4 text-red-500 font-semibold -mt-2">
                Password Does not Match
              </p>
            )}
            <button
              type="submit"
              onClick={handleSignUp}
              className="style-button btn-success rounded-lg bg-[#295700] hover:bg-[#4D732A] flex w-[400px] h-[50px] justify-center items-center gap-20 flex-shrink-0 text-white font-monda text-24 font-semibold leading-[140%] tracking-[0.96px] capitalize"
            >
              <Link to="/emailverification">Sign Up</Link>
            </button>
            <br />
            {/* <Link
              to=""
              className="style-button btn-success style-button btn-success rounded-lg bg-[#295700] hover:bg-[#4D732A] flex w-[400px] h-[50px] justify-center items-center gap-20 flex-shrink-0 text-white font-monda text-24 font-semibold leading-[140%] tracking-[0.96px] capitalize"
            >
              Sign Up with Google
            </Link> */}
            <p className="text-center mt-6">
              Do you have an account?
              <Link
                to="/signin"
                className="hover:text-[#4D732A] text-[#295700]"
              >
                Log In
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
